import { Box, styled } from '@mui/material';

import { palette } from '../../theme';
export const LanguageCounterBadgeBox = styled(Box)({
  backgroundColor: palette.tint.warning,
  borderRadius: '4px',
  padding: '2px 6px',
  fontSize: '0.75rem',
  fontWeight: 500,
  color: palette.text.warningText,
  display: 'flex',
  alignItems: 'center'
});